/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ContractDeliveryTargetsList,
  HangarInventoryTransfersParams,
  InventoryTransfer,
  InventoryTransferAcceptInput,
  InventoryTransferCreateInput,
  InventoryTransferReportInput,
  InventoryTransfersList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Hangar Contract Destinations
 */
export const hangarContractDestinations = (

 signal?: AbortSignal
) => {


      return axiosClient<ContractDeliveryTargetsList>(
      {url: `/hangar/contract-destinations`, method: 'GET', signal
    },
      );
    }




export const getHangarContractDestinationsQueryKey = () => {
    return [
    'hangar','contract-destinations'
    ] as const;
    }


export const getHangarContractDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof hangarContractDestinations>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarContractDestinations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarContractDestinationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarContractDestinations>>> = ({ signal }) => hangarContractDestinations(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarContractDestinations>>, TError, TData>
}

export type HangarContractDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarContractDestinations>>>
export type HangarContractDestinationsQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Contract Destinations
 */

export function useHangarContractDestinations<TData = Awaited<ReturnType<typeof hangarContractDestinations>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarContractDestinations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarContractDestinationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Inventory Transfers
 */
export const hangarInventoryTransfers = (
    params?: MaybeRefOrGetter<HangarInventoryTransfersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<InventoryTransfersList>(
      {url: `/hangar/inventory-transfers`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarInventoryTransfersQueryKey = (params?: MaybeRefOrGetter<HangarInventoryTransfersParams>,) => {
    return [
    'hangar','inventory-transfers', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarInventoryTransfersQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventoryTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarInventoryTransfersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryTransfersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventoryTransfers>>> = ({ signal }) => hangarInventoryTransfers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfers>>, TError, TData>
}

export type HangarInventoryTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventoryTransfers>>>
export type HangarInventoryTransfersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory Transfers
 */

export function useHangarInventoryTransfers<TData = Awaited<ReturnType<typeof hangarInventoryTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarInventoryTransfersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryTransfersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Hangar Inventory Transfer
 */
export const createHangarInventoryTransfer = (
    inventoryTransferCreateInput: MaybeRefOrGetter<InventoryTransferCreateInput>,
 signal?: AbortSignal
) => {
      inventoryTransferCreateInput = toValue(inventoryTransferCreateInput);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferCreateInput, signal
    },
      );
    }




export const getCreateHangarInventoryTransferMutationKey = () => ['createHangarInventoryTransfer'] as const;

export const getCreateHangarInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryTransfer>>, TError,CreateHangarInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryTransfer>>, TError,CreateHangarInventoryTransferMutationVariables, TContext> => {

const mutationKey = getCreateHangarInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarInventoryTransfer>>, CreateHangarInventoryTransferMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createHangarInventoryTransfer(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarInventoryTransfer>>>
    export type CreateHangarInventoryTransferMutationBody = InventoryTransferCreateInput
    export type CreateHangarInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarInventoryTransferMutationVariables = {data: InventoryTransferCreateInput}

    /**
 * @summary Create Hangar Inventory Transfer
 */
export const useCreateHangarInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventoryTransfer>>, TError,CreateHangarInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarInventoryTransfer>>,
        TError,
        CreateHangarInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Inventory Transfer
 */
export const hangarInventoryTransfer = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers/${id}`, method: 'GET', signal
    },
      );
    }




export const getHangarInventoryTransferQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','inventory-transfers',id
    ] as const;
    }


export const getHangarInventoryTransferQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventoryTransfer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryTransferQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventoryTransfer>>> = ({ signal }) => hangarInventoryTransfer(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfer>>, TError, TData>
}

export type HangarInventoryTransferQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventoryTransfer>>>
export type HangarInventoryTransferQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory Transfer
 */

export function useHangarInventoryTransfer<TData = Awaited<ReturnType<typeof hangarInventoryTransfer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventoryTransfer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryTransferQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Accept Hangar Inventory Transfer
 */
export const acceptHangarInventoryTransfer = (
    id: MaybeRefOrGetter<string>,
    inventoryTransferAcceptInput: MaybeRefOrGetter<InventoryTransferAcceptInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
inventoryTransferAcceptInput = toValue(inventoryTransferAcceptInput);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers/${id}/accept`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferAcceptInput, signal
    },
      );
    }




export const getAcceptHangarInventoryTransferMutationKey = () => ['acceptHangarInventoryTransfer'] as const;

export const getAcceptHangarInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>, TError,AcceptHangarInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>, TError,AcceptHangarInventoryTransferMutationVariables, TContext> => {

const mutationKey = getAcceptHangarInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>, AcceptHangarInventoryTransferMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  acceptHangarInventoryTransfer(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptHangarInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>>
    export type AcceptHangarInventoryTransferMutationBody = InventoryTransferAcceptInput
    export type AcceptHangarInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type AcceptHangarInventoryTransferMutationVariables = {id: string;data: InventoryTransferAcceptInput}

    /**
 * @summary Accept Hangar Inventory Transfer
 */
export const useAcceptHangarInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>, TError,AcceptHangarInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptHangarInventoryTransfer>>,
        TError,
        AcceptHangarInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptHangarInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel Hangar Inventory Transfer
 */
export const cancelHangarInventoryTransfer = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers/${id}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelHangarInventoryTransferMutationKey = () => ['cancelHangarInventoryTransfer'] as const;

export const getCancelHangarInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>, TError,CancelHangarInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>, TError,CancelHangarInventoryTransferMutationVariables, TContext> => {

const mutationKey = getCancelHangarInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>, CancelHangarInventoryTransferMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cancelHangarInventoryTransfer(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelHangarInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>>

    export type CancelHangarInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type CancelHangarInventoryTransferMutationVariables = {id: string}

    /**
 * @summary Cancel Hangar Inventory Transfer
 */
export const useCancelHangarInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>, TError,CancelHangarInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelHangarInventoryTransfer>>,
        TError,
        CancelHangarInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getCancelHangarInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Hangar Inventory Transfer
 */
export const declineHangarInventoryTransfer = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers/${id}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineHangarInventoryTransferMutationKey = () => ['declineHangarInventoryTransfer'] as const;

export const getDeclineHangarInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineHangarInventoryTransfer>>, TError,DeclineHangarInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineHangarInventoryTransfer>>, TError,DeclineHangarInventoryTransferMutationVariables, TContext> => {

const mutationKey = getDeclineHangarInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineHangarInventoryTransfer>>, DeclineHangarInventoryTransferMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  declineHangarInventoryTransfer(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineHangarInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof declineHangarInventoryTransfer>>>

    export type DeclineHangarInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type DeclineHangarInventoryTransferMutationVariables = {id: string}

    /**
 * @summary Decline Hangar Inventory Transfer
 */
export const useDeclineHangarInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineHangarInventoryTransfer>>, TError,DeclineHangarInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineHangarInventoryTransfer>>,
        TError,
        DeclineHangarInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineHangarInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Report Hangar Inventory Transfer
 */
export const reportHangarInventoryTransfer = (
    id: MaybeRefOrGetter<string>,
    inventoryTransferReportInput: MaybeRefOrGetter<InventoryTransferReportInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
inventoryTransferReportInput = toValue(inventoryTransferReportInput);

      return axiosClient<InventoryTransfer>(
      {url: `/hangar/inventory-transfers/${id}/report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferReportInput, signal
    },
      );
    }




export const getReportHangarInventoryTransferMutationKey = () => ['reportHangarInventoryTransfer'] as const;

export const getReportHangarInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportHangarInventoryTransfer>>, TError,ReportHangarInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportHangarInventoryTransfer>>, TError,ReportHangarInventoryTransferMutationVariables, TContext> => {

const mutationKey = getReportHangarInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportHangarInventoryTransfer>>, ReportHangarInventoryTransferMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reportHangarInventoryTransfer(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportHangarInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof reportHangarInventoryTransfer>>>
    export type ReportHangarInventoryTransferMutationBody = InventoryTransferReportInput
    export type ReportHangarInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type ReportHangarInventoryTransferMutationVariables = {id: string;data: InventoryTransferReportInput}

    /**
 * @summary Report Hangar Inventory Transfer
 */
export const useReportHangarInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportHangarInventoryTransfer>>, TError,ReportHangarInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reportHangarInventoryTransfer>>,
        TError,
        ReportHangarInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getReportHangarInventoryTransferMutationOptions(options), queryClient);
    }
